import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logoDanes from '../../assets/logo-danes.png';
import logoPosgo from '../../assets/logo-posgo.png';
import fondoDanes from '../../assets/fondo-danes.png';

const ThankYouScreen = ({ previewNumber } = {}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const orderNumber = previewNumber || location.state?.orderNumber;
    const isPreview = !!previewNumber;
    const [countdown, setCountdown] = useState(10);

    useEffect(() => {
        if (isPreview) return;
        if (countdown <= 0) {
            navigate('/');
            return;
        }

        const timer = setTimeout(() => {
            setCountdown(countdown - 1);
        }, 1000);

        return () => clearTimeout(timer);
    }, [countdown, navigate, isPreview]);

    return (
        <div
            onClick={() => navigate('/')}
            style={{
                position: 'fixed',
                inset: 0,
                zIndex: 50,
                cursor: 'pointer',
                overflow: 'hidden',
                background: `linear-gradient(rgba(255,255,255,0.70), rgba(255,255,255,0.80)), url(${fondoDanes})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '40px',
            }}
        >
            <img
                src={logoDanes}
                alt="Danés"
                style={{
                    width: 'min(38vw, 340px)',
                    height: 'auto',
                    filter: 'drop-shadow(0 14px 32px rgba(0,0,0,0.22))',
                    pointerEvents: 'none',
                }}
            />

            <span style={{
                fontSize: 'clamp(2.2rem, 5vw, 3.4rem)',
                fontWeight: '800',
                color: '#009542',
                fontFamily: 'Quicksand, sans-serif',
                pointerEvents: 'none',
            }}>
                ¡Gracias por tu compra!
            </span>

            {orderNumber && (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '10px',
                    pointerEvents: 'none',
                }}>
                    <span style={{
                        fontSize: '1.6rem',
                        fontWeight: '700',
                        color: '#6b7280',
                        fontFamily: 'Quicksand, sans-serif',
                        textTransform: 'uppercase',
                        letterSpacing: '2px',
                    }}>
                        Tu número de pedido
                    </span>
                    <span style={{
                        fontSize: '7rem',
                        fontWeight: '900',
                        color: '#FFFFFF',
                        fontFamily: 'Quicksand, sans-serif',
                        lineHeight: 1,
                        whiteSpace: 'nowrap',
                        background: '#009542',
                        border: '3px solid #007a36',
                        borderRadius: '28px',
                        padding: '20px 50px',
                        boxShadow: '0 10px 30px rgba(0,149,66,0.30)',
                    }}>
                        {orderNumber}
                    </span>
                </div>
            )}

            <span style={{
                fontSize: '1.1rem',
                color: '#6b7280',
                fontFamily: 'Quicksand, sans-serif',
                pointerEvents: 'none',
            }}>
                Volviendo al inicio en {countdown}s — toca la pantalla para volver ahora
            </span>

            {/* Logo PosGo.cl abajo a la izquierda */}
            <div style={{
                position: 'fixed',
                bottom: '20px',
                left: '20px',
                zIndex: 9999,
                background: 'white',
                padding: '10px 18px',
                borderRadius: '14px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                display: 'flex',
                alignItems: 'center',
                gap: '14px',
                pointerEvents: 'none',
            }}>
                <img
                    src={logoPosgo}
                    alt="PosGo"
                    style={{ height: '55px', width: 'auto', display: 'block' }}
                />
                <span style={{
                    fontSize: '1.8rem',
                    fontWeight: '700',
                    color: '#db2113',
                    fontFamily: 'Quicksand, sans-serif',
                    lineHeight: 1,
                }}>
                    PosGo.cl
                </span>
            </div>
        </div>
    );
};

export default ThankYouScreen;
